/* ============================================================
   KTZ · Shoppable Videos — reproductor y add-to-cart
   CERO dependencias externas. Es la razon por la que se construye en vez de
   comprar: el mayor contribuyente a un INP pobre son los scripts de TERCEROS
   〔HTTP Archive Web Almanac 2024〕, y el INP de campo de la casa es 145 ms
   con solo ~55 ms de margen al umbral 📉〔14 ago 2026〕.

   TRES DECISIONES QUE CUIDAN EL RENDIMIENTO
   1. FACHADA: el <video> nace sin `src`. La fuente se inyecta cuando la
      tarjeta se acerca al viewport. Sin esto, N videos empiezan a descargar
      a la vez y tumban la pagina en movil.
   2. IntersectionObserver, no eventos de scroll: el scroll dispara cientos de
      veces por segundo y es justo lo que degrada el INP.
   3. Solo UNO reproduce a la vez. Al entrar uno, se pausan los demas.

   🔴 LOS VIDEOS SE QUEDABAN ESTATICOS 〔Lalo, 8 sep 2026: "en ocasiones los
   videos se quedan estaticos, tanto en web como en movil. A veces el ultimo,
   los ultimos tres… luego regreso y el primero ya se quedo estatico"〕.
   Eran CINCO fallas encimadas, no una — cada arreglo esta marcado abajo:
     1. `fuente()` reasignaba el `src` al primer video, que ya lo traia del
        HTML, y esa recarga ABORTABA su play() 〔AbortError, medido〕.
     2. El fallo de play() se tragaba con un catch vacio y no se reintentaba.
     3. Nada revivia un video congelado: el unico disparador era un cambio de
        interseccion, y al volver de otra app la geometria NO cambia.
     4. Al deslizar rapido, dos laminas se pausaban entre si y quedaban las dos
        muertas.
     5. La fuente no se soltaba nunca: 5 videos peleando por los pocos
        decodificadores del telefono, que el navegador reparte en silencio.
   🔑 Y sobre todos, EL VIGILANTE: mide cada segundo si el reloj del video que
   deberia estar sonando AVANZO. Es la unica señal que distingue "reproduciendo"
   de "congelado" — no existe evento para el decodificador robado.
   ============================================================ */
(function () {
  'use strict';

  var UMBRAL = 0.6;            // cuanto del video debe verse para reproducir
  var CERCA = '260px';         // margen para empezar a cargar ANTES de que entre

  function fuente(video) {
    // La fachada: pasar de data-src a src.
    if (video.dataset.cargado === '1') return;
    var src = video.dataset.src;
    if (!src) return;
    /* 🔴 DEFECTO 1 〔medido 8 sep 2026〕: el PRIMER video de cada carril nace ya
       con `src` en el HTML, y aqui se le reasignaba el MISMO valor. Asignar
       `src` obliga al navegador a RECARGAR el elemento, y esa recarga ABORTA el
       play() que va en camino:
         AbortError: The play() request was interrupted by a new load request
       El video quedaba pausado con readyState 0 — estatico, y con el script
       creyendo que reproducia. Es el «regreso y el primero ya se quedo
       estatico» de Lalo. Solo se asigna si de verdad falta. */
    if (!video.getAttribute('src')) { video.src = src; }
    video.dataset.cargado = '1';
  }

  /* 🔴 DEFECTO 2 〔8 sep 2026〕: el fallo de play() se tragaba con un catch vacio
     —"si el navegador bloquea el autoplay, NO se insiste"—, pero por ahi no solo
     llega el autoplay bloqueado: llega el AbortError de arriba y llega el fallo
     por falta de DECODIFICADORES en movil. Como el unico disparador de la
     reproduccion era un cambio de interseccion, y la geometria ya no cambia, un
     tropiezo de un segundo se volvia PERMANENTE. Ahora se marca y el vigilante
     lo reintenta. */
  function anotarFallo(video) {
    return function (e) { video.dataset.fallo = (e && e.name) ? e.name : '1'; };
  }

  function reproducir(video) {
    fuente(video);
    video.dataset.debe = '1';
    var p = video.play();
    if (p && p.catch) { p.catch(anotarFallo(video)); }
  }

  function reintentar(video) {
    // Si se le solto la fuente por lejania, se le devuelve antes de insistir.
    if (!video.getAttribute('src') && video.dataset.src) {
      video.dataset.cargado = '';
      fuente(video);
    }
    var p = video.play();
    if (p && p.catch) { p.catch(anotarFallo(video)); }
  }

  /* 🔴 DEFECTO 3 〔8 sep 2026〕: NADA revivia un video congelado. Se reanuda en
     las dos puertas por las que el cliente se va y vuelve — cambiar de app o de
     pestaña (`visibilitychange`) y el boton "atras" (`pageshow`, que restaura la
     pagina del bfcache SIN recargarla). Sin esto, salir de la app y volver
     dejaba la lamina muerta hasta recargar a mano. */
  /* ⚠️ SE REINTENTA ESCALONADO, NO UNA VEZ 〔8 sep 2026, Lalo desde su telefono:
     «al tener video abierto, luego cambiar a instagram y regresar, se congelo;
     cambiando a otro video y regresando funciona»〕.
     🔑 Esa segunda mitad es la pista: cambiar de lamina SI lo revive porque ese
     camino pasa por `reproducir()`. Lo que fallaba era el intento UNICO al
     volver — en un telefono, el instante en que llega `visibilitychange` es el
     mas fragil que hay: el sistema todavia puede negar el arranque. Se insiste
     durante los primeros segundos en vez de rendirse al primer no. */
  function reanudar() {
    [0, 400, 1200, 2500].forEach(function (ms) {
      setTimeout(function () {
        if (document.hidden) return;
        document.querySelectorAll('video.ktzv__video').forEach(function (v) {
          if (v.dataset.debe === '1' && (v.paused || v.readyState === 0)) {
            reintentar(v);
          }
        });
      }, ms);
    });
  }

  /* Un toque en la pantalla levanta lo que la politica de autoplay no dejo
     arrancar. Va SIN `once`: la primera version lo consumia al cargar y ya no
     servia para el caso que importa, que ocurre al volver de otra app. Solo
     hace algo si de verdad hay un video marcado y muerto. */
  ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      var hayMuerto = [].some.call(
        document.querySelectorAll('video.ktzv__video'),
        function (v) { return v.dataset.debe === '1' && v.paused; });
      if (hayMuerto) { reanudar(); }
    }, { passive: true });
  });

  /* ---------------- silencio / sonido ---------------- */
  var ICONO_MUDO = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z"></path><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>';
  var ICONO_SUENA = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z"></path><path d="M15.5 8.5a5 5 0 0 1 0 7"></path><path d="M18.5 5.5a9 9 0 0 1 0 13"></path></svg>';

  function pintarBoton(boton, mudo) {
    boton.innerHTML = mudo ? ICONO_MUDO : ICONO_SUENA;
    boton.setAttribute('aria-label', mudo ? 'Activar sonido' : 'Silenciar');
    boton.setAttribute('aria-pressed', mudo ? 'false' : 'true');
  }

  /* ---------------- add to cart ---------------- */
  function agregar(boton) {
    var id = boton.dataset.variante;
    if (!id) return;
    var original = boton.textContent;
    boton.disabled = true;
    boton.textContent = '…';

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      // `_video` con guion bajo: se GUARDA en el pedido y NO se le muestra al
      // cliente. Es lo que convierte "creo que el video vende" en evidencia
      // directa — la unica que acepta la regla de la casa.
      body: JSON.stringify({
        items: [{
          id: Number(id),
          quantity: 1,
          properties: boton.dataset.video ? { _video: boton.dataset.video } : undefined
        }]
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.j && res.j.description || 'no se pudo agregar'); }
        boton.dataset.estado = 'ok';
        boton.textContent = 'Agregado';
        avisarAlTema();
      })
      .catch(function (e) {
        boton.dataset.estado = 'error';
        // El mensaje real del carrito sirve mas que un "error" generico:
        // casi siempre es "sin existencias" y el cliente debe poder leerlo.
        boton.textContent = (e && e.message ? String(e.message).slice(0, 22) : 'No se pudo');
      })
      .then(function () {
        setTimeout(function () {
          boton.disabled = false;
          boton.textContent = original;
          delete boton.dataset.estado;
        }, 2200);
      });
  }

  /* 🔴 DEFECTO CORREGIDO 〔Lalo lo probó, 7 sep 2026: "si hace la accion pero no
     se refleja en el carrito hasta refrescar"〕.

     LA CAUSA: la primera version disparaba `cart:refresh` y `cart:build`, dos
     eventos que Kbot INVENTO. Este tema es arquitectura Horizon y usa otros.
     🔑 Se leyeron del propio tema en vez de suponerlos:
       · `assets/events.js`      -> ThemeEvents.cartUpdate = 'cart:update'
       · `assets/cart-icon.js`   -> escucha ThemeEvents.cartUpdate y lee
                                    event.detail.data.itemCount
       · `assets/cart-drawer.js` -> escucha CartAddEvent.eventName, que resulta
                                    ser EL MISMO 'cart:update'
     Asi que UN solo evento actualiza la burbuja y avisa al cajon.

     ⚠️ Dos detalles que el codigo del tema deja ver y hay que respetar:
     1. Es un `Event` con `detail` asignado, NO un `CustomEvent`.
     2. Si `data.source` fuera 'product-form-component', el tema SUMA al conteo
        en vez de fijarlo. Con otro `source` usa `itemCount` tal cual — que es
        lo correcto aqui, porque el numero sale del carrito real. */
  function avisarAlTema() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = {
          resource: c,
          sourceId: 'ktz-videos',
          data: {
            source: 'ktz-videos',
            itemCount: c.item_count,
            // No se abre el cajon encima del video: el cliente esta viendo el
            // feed y taparselo interrumpe justo lo que vino a hacer. La burbuja
            // le confirma que se agrego.
            deferDrawerOpen: true
          }
        };
        document.dispatchEvent(ev);

        // Red de seguridad: si alguna version del tema no reacciona al evento,
        // la burbuja igual queda con el numero correcto.
        document.querySelectorAll('[ref="cartBubbleCount"], .cart-count-bubble span:first-child, [data-cart-count]')
          .forEach(function (el) { el.textContent = c.item_count < 100 ? String(c.item_count) : ''; });
        pintarCuenta(c.item_count);
      })
      .catch(function () {});
  }

  /* 🔴 DEFECTO CORREGIDO 〔Lalo, 7 sep 2026: "al eliminar producto del carrito y
     regresando a vista inmersiva se sigue mostrando en la barra el indicador de
     que tengo cosas en carrito"〕. Eran DOS fallas encimadas:

     1. **El contador nacia con `{{ cart.item_count }}` del servidor y solo se
        actualizaba al agregar DESDE el video.** Si el cliente se iba al carrito,
        borraba algo y volvia con "atras", la pagina se restaura del **bfcache**
        —sin recargar— y el numero quedaba congelado.
        🔑 El tema ya resuelve esto: `cart-icon.js` escucha `pageshow`. Se copia
        su enfoque en vez de inventar otro.
     2. **Con el carrito VACIO pintaba un `0`**, que se lee como "tienes algo".
        Una burbuja de carrito no muestra cero: desaparece. */
  function pintarCuenta(n) {
    document.querySelectorAll('[data-ktzv-cuenta]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      // vacio = sin indicador. No es cosmetico: un "0" visible miente.
      el.hidden = !n;
      el.style.display = n ? '' : 'none';
    });
  }

  function refrescarCuenta() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { pintarCuenta(c.item_count); })
      .catch(function () {});
  }


  /* ---------------- compartir ---------------- */
  /* 🔒 Lalo, 7 sep 2026. El enlace lleva a NUESTRA pagina con ancla a ese video,
     no a la red social de origen: compartir tiene que traer trafico al sitio.
     Y lleva UTM para que ese trafico sea ATRIBUIBLE — la regla de la casa es
     venta directa o nada, y sin UTM un clic compartido llega como "directo". */
  /* 🔒 Lalo, 8 sep 2026 — se comparte LA PAGINA DEL VIDEO, no el feed con ancla.
     El enlace viejo era `/pages/videos#v-<handle>`, y **el fragmento nunca llega
     al servidor**: WhatsApp pedia la pagina pelona, asi que los diez videos
     daban la misma miniatura y el mismo titulo. Con URL real cada video comparte
     SU imagen y SU texto.
     ⚖️ Los UTM se conservan identicos: cambia el destino, no la atribucion. */
  function enlaceDe(handle) {
    var u = new URL('/pages/video/' + handle, location.origin);
    u.searchParams.set('utm_source', 'compartir');
    u.searchParams.set('utm_medium', 'social');
    u.searchParams.set('utm_campaign', 'videos-shoppable');
    return u.toString();
  }

  function aviso(texto) {
    var d = document.createElement('div');
    d.className = 'ktzv__aviso';
    d.textContent = texto;
    document.body.appendChild(d);
    setTimeout(function () { d.remove(); }, 2400);
  }

  function compartir(boton) {
    var url = enlaceDe(boton.dataset.ktzvShare);
    var titulo = boton.dataset.titulo || 'Kollectoyz';
    // `navigator.share` abre la hoja NATIVA del sistema — en movil es lo que la
    // gente ya sabe usar. En escritorio casi nunca existe: se copia y se avisa.
    if (navigator.share) {
      navigator.share({ title: titulo, text: titulo, url: url })
        .then(function () { boton.dataset.ok = '1'; setTimeout(function(){ delete boton.dataset.ok; }, 1600); })
        .catch(function () { /* el cliente cancelo: no es un error */ });
      return;
    }
    var copiar = navigator.clipboard && navigator.clipboard.writeText
      ? navigator.clipboard.writeText(url)
      : Promise.reject();
    copiar.then(function () {
      boton.dataset.ok = '1';
      aviso('Enlace copiado');
      setTimeout(function(){ delete boton.dataset.ok; }, 1600);
    }).catch(function () {
      // Ultimo recurso: mostrar el enlace para que lo copie a mano.
      window.prompt('Copia el enlace del video:', url);
    });
  }

  /* ---------------- el carrito abre el CAJON ---------------- */
  /* 🪤 QUE UN METODO EXISTA Y NO TRUENE NO ES QUE HAYA FUNCIONADO 〔7 sep 2026〕.
     El tema expone `open()` y `showDialog()`; los dos se ejecutan sin error y
     **el dialogo se queda cerrado** (`open:false`, `display:none`). El que si
     abre es el `showModal()` NATIVO del <dialog>, y ademas lo pone en la capa
     superior — por encima del overlay inmersivo, que es justo lo que hace falta.
     Por eso NO se encadena por "existe el metodo": se llama, se MIDE si abrio,
     y si no, se pasa al siguiente. Si ninguno abre, se deja navegar al /cart. */
  function abrirCajon(ev) {
    var cajon = document.querySelector('cart-drawer-component');
    var dlg = cajon && cajon.querySelector('dialog');
    if (!cajon || !dlg) return;            // sin cajon, se navega al /cart

    ev.preventDefault();
    try { if (typeof cajon.open === 'function') cajon.open(); } catch (e) {}
    if (dlg.open) return;
    try { if (typeof cajon.showDialog === 'function') cajon.showDialog(); } catch (e) {}
    if (dlg.open) return;
    try { if (dlg.showModal) dlg.showModal(); } catch (e) {}
    if (dlg.open) return;

    // Ninguno abrio: se cumple la promesa del enlace en vez de dejarlo muerto.
    window.location.href = ev.currentTarget.getAttribute('href') || '/cart';
  }

  /* Si alguien llega con #v-<handle>, se abre en ESE video. Sin esto, compartir
     un video llevaria siempre al primero y el enlace no cumpliria su promesa. */
  function irAlAncla(raiz) {
    if (!location.hash || location.hash.indexOf('#v-') !== 0) return;
    var destino = raiz.querySelector(CSS.escape ? '#' + CSS.escape(location.hash.slice(1)) : location.hash);
    var carril = raiz.querySelector('.ktzv__feed');
    if (destino && carril) { carril.scrollTop = destino.offsetTop; }
  }

  /* ---------------- arranque ---------------- */
  /* MODO INMERSIVO: se bloquea el scroll del DOCUMENTO para que solo quede uno,
     el del feed. Sin esto el dedo mueve la pagina o el feed segun donde caiga, y
     la lamina se queda a medias — el defecto que reporto Lalo.
     Se marcan html Y body: iOS Safari ignora el bloqueo si solo se pone en uno. */
  function inmersivo(raiz) {
    if (!raiz.classList.contains('ktzv--full')) return;
    document.documentElement.classList.add('ktzv-bloqueado');
    document.body.classList.add('ktzv-bloqueado');
    // El overlay tapa el header del tema: se le esconde para que no asome
    // por debajo en navegadores con barras translucidas.
    var salir = raiz.querySelector('.ktzv__salir');
    if (salir) { salir.addEventListener('click', function () {
      document.documentElement.classList.remove('ktzv-bloqueado');
      document.body.classList.remove('ktzv-bloqueado');
    }); }
  }

  function iniciar(raiz) {
    if (!raiz || raiz.dataset.ktzvIniciado === '1') return;
    raiz.dataset.ktzvIniciado = '1';
    inmersivo(raiz);

    var videos = raiz.querySelectorAll('video.ktzv__video');
    if (!videos.length) return;

    // Ultimo ratio conocido de cada video: la base para elegir cual manda.
    var ratios = new WeakMap();

    function elegir() {
      var mejor = null, mejorR = 0;
      videos.forEach(function (v) {
        var r = ratios.get(v) || 0;
        if (r > mejorR) { mejorR = r; mejor = v; }
      });
      // Primero se apagan todos los que no mandan, y DESPUES se arranca el que
      // manda: al reves, el pausado de otro podia caerle encima al que arranca.
      videos.forEach(function (v) {
        if (v === mejor) return;
        v.dataset.debe = '0';
        if (!v.paused) { v.pause(); }
      });
      if (mejor && mejorR >= UMBRAL) { reproducir(mejor); }
      soltarLejanos(mejor);
    }

    /* 🔴 DEFECTO 5 〔8 sep 2026〕: la fuente no se soltaba NUNCA. Un <video> con
       `src` retiene un DECODIFICADOR del aparato aunque este pausado, y en un
       telefono son pocos: con 5 cargados a la vez el navegador empieza a
       quitarselo a unos para darselo a otros, en SILENCIO y sin evento alguno.
       Es lo que explica que «al dejarlo un tiempo ya el ultimo funciona» y que
       al volver arriba el primero este congelado.
       Se conservan el que manda y sus dos vecinos —los que el cliente puede
       alcanzar con un gesto—; el resto se queda con su portada, que es
       exactamente lo que se ve de ellos estando fuera de pantalla. */
    function soltarLejanos(activo) {
      if (!activo || videos.length <= 3) return;
      var i = [].indexOf.call(videos, activo);
      videos.forEach(function (v, j) {
        if (Math.abs(j - i) <= 1) return;
        if (v.dataset.cargado !== '1') return;
        v.dataset.debe = '0';     // ⚠️ ANTES de pausar: el vigilante mira `debe`
        v.pause();
        v.removeAttribute('src');
        v.load();                 // sin esto el decodificador NO se libera
        v.dataset.cargado = '';
      });
    }

    /* 🔴 EL VIGILANTE — la red que cubre lo que no se puede prever 〔8 sep 2026〕.
       Los cuatro defectos de arriba tienen arreglo directo, pero queda uno que
       NO se puede detectar de antemano: el navegador le quita el decodificador a
       un video sin avisar, y el elemento se queda con `paused:false` y la imagen
       congelada. No hay evento para eso.
       🔑 Lo unico que distingue «reproduciendo» de «congelado» es si el reloj del
       video AVANZO. Eso se MIDE, cada segundo, y si no avanzo se vuelve a
       arrancar. Es barato: leer `currentTime` no toca el layout, y en segundo
       plano ni corre. */
    function vigilar() {
      var previo = new WeakMap();
      var ocultoAntes = document.hidden;
      var ciclos = 0;
      setInterval(function () {
        ciclos++;
        /* 🔑 EL REGRESO SE DETECTA MIRANDO, NO ESPERANDO EL EVENTO 〔8 sep 2026〕.
           `visibilitychange` puede llegar tarde, llegar antes de que el sistema
           permita reproducir, o no llegar. El flanco oculto→visible se ve solo
           comparando con el tick anterior, y eso no depende de nadie. */
        var oculto = document.hidden;
        if (ocultoAntes && !oculto) { ocultoAntes = oculto; reanudar(); return; }
        ocultoAntes = oculto;
        if (oculto) return;   // en segundo plano no decodifica: no es falla

        videos.forEach(function (v) {
          if (v.dataset.debe !== '1') return;
          var tenia = previo.has(v);          // ⚠️ ANTES del set, o siempre es true
          var t = v.currentTime;
          var avanzo = tenia && t !== previo.get(v);
          previo.set(v, t);
          if (!tenia) return;                 // primer tick: nada con que comparar
          if (avanzo && !v.paused) { delete v.dataset.fallo; return; }
          /* ⚠️ Un autoplay negado NO se abandona: se ESPACIA. La primera version
             hacia `return` para siempre ante un `NotAllowedError`, y eso volvia
             a meter por la puerta de atras el defecto que este archivo arregla
             — el video quedaba muerto hasta cambiar de lamina, que es
             exactamente lo que reporto Lalo desde su telefono. */
          if (v.dataset.fallo === 'NotAllowedError' && ciclos % 2 !== 0) return;
          reintentar(v);
        });
      }, 1000);
    }

    /* Cuando el NAVEGADOR pausa por su cuenta un video que deberia estar
       sonando —lo hace al mandar la pagina a segundo plano— queda constancia
       aqui mismo, sin depender de ningun evento de la pagina. Si ya estamos a
       la vista se levanta enseguida; si no, el flanco del vigilante lo hara al
       volver. `elegir()` y `soltarLejanos()` marcan `debe='0'` ANTES de pausar,
       asi que sus pausas legitimas no entran por aqui. */
    videos.forEach(function (v) {
      v.addEventListener('pause', function () {
        if (v.dataset.debe !== '1' || document.hidden) return;
        setTimeout(function () {
          if (v.dataset.debe === '1' && v.paused && !document.hidden) {
            reintentar(v);
          }
        }, 250);
      });
    });

    // 1) precarga por cercania (la fachada)
    if ('IntersectionObserver' in window) {
      /* ⚠️ SIN `unobserve` a proposito 〔8 sep 2026〕: la fuente de un video
         lejano ahora se SUELTA (ver `soltarLejanos`), asi que hace falta que
         este observador siga vivo para volver a precargarlo cuando el cliente
         regrese hacia el. `fuente()` es idempotente, no cuesta repetirla. */
      var cerca = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) { if (e.isIntersecting) { fuente(e.target); } });
      }, { rootMargin: CERCA });
      videos.forEach(function (v) { cerca.observe(v); });

      // 2) reproducir el que se esta viendo, pausar el resto
      /* 🔴 DEFECTO 4 〔8 sep 2026〕: antes CADA entrada del lote llamaba a
         reproducir(), y reproducir() pausaba a los demas. Al deslizar rapido,
         una lamina que ya paso podia procesarse DESPUES de la que quedo en
         pantalla: arrancaba, pausaba a la buena, y enseguida se pausaba ella
         misma por su propia entrada. Quedaban las DOS muertas, y ya no llegaban
         mas avisos porque el dedo se detuvo — el «a veces el ultimo, los
         ultimos tres» que reporto Lalo.
         🔑 Ahora el lote solo actualiza los ratios y UNA funcion decide: manda
         el de mayor ratio. Y se elige por RATIO, no por scrollTop, porque el
         MISMO archivo gobierna el carril VERTICAL del feed y el HORIZONTAL de
         la tira de la ficha de producto. */
      var visible = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) { ratios.set(e.target, e.intersectionRatio); });
        elegir();
      }, { threshold: [0, 0.25, UMBRAL, 0.9, 1] });
      videos.forEach(function (v) { visible.observe(v); });
      vigilar();
    } else {
      // Sin IntersectionObserver: se cargan pero no se autoreproducen.
      videos.forEach(fuente);
    }

    // 3) silencio/sonido — el estado se comparte entre todos los videos
    raiz.querySelectorAll('.ktzv__mute').forEach(function (b) {
      pintarBoton(b, true);
      b.addEventListener('click', function () {
        var mudo = !raiz.dataset.sonido;
        if (mudo) { raiz.dataset.sonido = '1'; } else { delete raiz.dataset.sonido; }
        raiz.querySelectorAll('video.ktzv__video').forEach(function (v) { v.muted = !mudo; });
        raiz.querySelectorAll('.ktzv__mute').forEach(function (x) { pintarBoton(x, !mudo); });
      });
    });

    // 4) add to cart
    raiz.querySelectorAll('.ktzv__add').forEach(function (b) {
      b.addEventListener('click', function (ev) { ev.preventDefault(); agregar(b); });
    });

    // 5) navegacion de ESCRITORIO: flechas visibles y teclado.
    //    En movil el gesto basta; en escritorio no hay gesto, y sin control
    //    visible el cliente no descubre que hay mas videos abajo.
    var carrilNav = raiz.querySelector('.ktzv__feed');
    /* 🪤 `scrollTo({behavior:'smooth'})` PELEA con `scroll-snap-type: mandatory`:
       el navegador arranca la animacion y el anclaje la revierte a medias.
       📉 Medido: tras el clic, scrollTop volvia a ~0. Con `scrollIntoView` sobre
       la lamina destino el anclaje COOPERA en vez de competir. */
    function irA(dir) {
      if (!carrilNav) return;
      var laminas = [].slice.call(carrilNav.querySelectorAll('.ktzv__slide'));
      if (!laminas.length) return;
      var alto = carrilNav.clientHeight || 1;
      var actual = Math.round(carrilNav.scrollTop / alto);
      var destino = Math.min(Math.max(actual + dir, 0), laminas.length - 1);
      // 🪤 Ni `scrollTo({behavior:'smooth'})` ni `scrollIntoView` funcionan aqui:
      //    el primero pelea con `scroll-snap`, y el segundo intenta desplazar el
      //    DOCUMENTO —que esta bloqueado en modo inmersivo— en vez del carril.
      //    📉 Medido: la asignacion directa de `scrollTop` si mueve (57 -> 804).
      //    La animacion la pone el CSS con `scroll-behavior`, que si coopera.
      carrilNav.scrollTop = destino * alto;
      actualizarFlechas(destino, laminas.length);
    }
    function actualizarFlechas(i, n) {
      var prev = raiz.querySelector('[data-ktzv-ir="-1"]');
      var next = raiz.querySelector('[data-ktzv-ir="1"]');
      // Una flecha que no lleva a ningun lado se apaga: es informacion, no adorno.
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
    }
    raiz.querySelectorAll('[data-ktzv-ir]').forEach(function (b) {
      b.addEventListener('click', function () { irA(Number(b.dataset.ktzvIr)); });
    });
    if (carrilNav) {
      var laminasIni = carrilNav.querySelectorAll('.ktzv__slide');
      actualizarFlechas(0, laminasIni.length);
      // tambien al desplazarse con la rueda o el dedo, no solo con las flechas
      carrilNav.addEventListener('scroll', function () {
        var alto = carrilNav.clientHeight || 1;
        actualizarFlechas(Math.round(carrilNav.scrollTop / alto), laminasIni.length);
      }, { passive: true });
    }
    if (raiz.classList.contains('ktzv--full')) {
      document.addEventListener('keydown', function (e) {
        // No se secuestra el teclado si el cliente esta escribiendo
        var t = e.target;
        if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return;
        if (e.key === 'ArrowDown' || e.key === 'PageDown') { e.preventDefault(); irA(1); }
        else if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); irA(-1); }
      });
    }

    // 6) compartir y el carrito al cajon
    raiz.querySelectorAll('[data-ktzv-share]').forEach(function (b) {
      b.addEventListener('click', function () { compartir(b); });
    });
    var lnkCarrito = raiz.querySelector('[data-ktzv-cajon]');
    if (lnkCarrito) { lnkCarrito.addEventListener('click', abrirCajon); }
    irAlAncla(raiz);

    // 7) la guia de deslizar se va al primer movimiento
    var guia = raiz.querySelector('.ktzv__guia');
    var carril = raiz.querySelector('.ktzv__feed');
    if (guia && carril) {
      carril.addEventListener('scroll', function () { guia.remove(); }, { once: true, passive: true });
      setTimeout(function () { if (guia.parentNode) guia.remove(); }, 7000);
    }
  }

  function todo() {
    document.querySelectorAll('.ktzv').forEach(iniciar);
    if (document.querySelector('[data-ktzv-cuenta]')) { refrescarCuenta(); }
  }

  /* Las tres puertas por las que el carrito puede cambiar SIN que este script se
     entere. Se cubren las tres, que es lo que hace que el numero no mienta:
       · `pageshow` con `persisted` -> volvio con "atras" desde el bfcache
       · `visibilitychange`         -> volvio de otra pestaña donde compro/borro
       · `cart:update`              -> el propio tema movio el carrito (cajon) */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && document.querySelector('[data-ktzv-cuenta]')) { refrescarCuenta(); }
    // Volver con "atras" restaura la pagina del bfcache SIN recargarla: el video
    // quedo pausado y nadie mas lo iba a levantar.
    if (e.persisted) { reanudar(); }
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && document.querySelector('[data-ktzv-cuenta]')) { refrescarCuenta(); }
    // El cliente cambio de app o de pestaña y volvio. El navegador pauso al
    // irse; la geometria no cambio, asi que el observador NO va a disparar.
    reanudar();
  });
  document.addEventListener('cart:update', function (e) {
    if (!document.querySelector('[data-ktzv-cuenta]')) return;
    var n = e && e.detail && e.detail.data ? e.detail.data.itemCount : null;
    // Si el evento no trae el conteo, NO se adivina: se relee el carrito.
    if (typeof n === 'number' && (!e.detail.data.source || e.detail.data.source !== 'ktz-videos')) {
      pintarCuenta(n);
    } else if (typeof n !== 'number') {
      refrescarCuenta();
    }
  });

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', todo); }
  else { todo(); }
  // El editor de temas re-renderiza secciones sin recargar la pagina.
  document.addEventListener('shopify:section:load', function (e) {
    (e.target.querySelectorAll ? e.target.querySelectorAll('.ktzv') : []).forEach(iniciar);
  });
})();
